import { useMutation } from '@tanstack/react-query';
import {
  invalidateListAnnouncementsQueryKey,
  invalidateLoadAnnouncementItemsQuery,
} from '@/hooks';
import { AnnouncementItemDTO } from '@/model';
import { saveAnnouncementItemAPI } from '@/service';

const saveAnnouncementItemMutationKey = ['saveAnnouncementItem'];

export const useSaveAnnouncementItemMutation = () => {
  return useMutation({
    mutationKey: saveAnnouncementItemMutationKey,
    mutationFn: (request: AnnouncementItemDTO) => saveAnnouncementItemAPI(request),
    onSuccess: () =>
      Promise.all([
        invalidateListAnnouncementsQueryKey(),
        invalidateLoadAnnouncementItemsQuery(),
      ]),
  });
};
